import queryString from 'query-string';
import { ApplicationSuccessType } from '../../../models/ApplicationSuccessResult';
import { ApplicationResult } from '../../../utilities/post-notification-handler';

type AccessCodeResultArguments = {
  accessCode: string;
  credentialsId: string;
};

export class AccessCodeResult implements ApplicationResult {
  accessCode: string;

  credentialsId: string;

  constructor({ accessCode, credentialsId }: AccessCodeResultArguments) {
    this.accessCode = accessCode;
    this.credentialsId = credentialsId;
  }

  buildQueryPath() {
    return queryString.stringify({
      credentialsId: this.credentialsId,
      credentials_id: this.credentialsId,
      [ApplicationSuccessType.CODE]: this.accessCode,
    });
  }

  buildIframeMessage() {
    return JSON.stringify({
      type: ApplicationSuccessType.CODE,
      data: this.accessCode,
      additionalInformation: {
        credentialsId: this.credentialsId,
      },
    });
  }
}
